import useChartDateFormatter from '@Dashboard/RiskUser/useChartDateFormatter';
import { TimeRangeEnum } from '@Dashboard/TimeRangeSelector';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import { ServiceNameEnum } from '@Types/index';
import { SERVICE_NAME_MAP, SERVICE_NAME_ORDER_MAP } from '@Utils/service';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ECharts, EChartsProps } from 'src/ECharts';
import {
  dashboardServiceLineSeries,
  dashboardTimerangeXData,
} from 'src/ECharts/utils';

export interface ServiceTimeRangeCountProps extends EChartsProps {
  data: Record<string, { timerange: Record<string, number> }>;
  interval: string;
}

export const ServiceTimeRangeCount = (props: ServiceTimeRangeCountProps) => {
  const { data: _data, interval, ...echartsProps } = props;
  const { t } = useTranslation();
  const timeModel = useUtcOffsetStore();
  const { format } = useChartDateFormatter();

  const data = useMemo(() => _data ?? {}, [_data]);

  const series = useMemo(() => {
    const services = Object.keys(data);
    // Check if all services are in ES
    if (services.every((s) => SERVICE_NAME_MAP.get(s))) {
      // Sort by service order
      services.sort((s1, s2) => {
        return (
          SERVICE_NAME_ORDER_MAP[SERVICE_NAME_MAP.get(s1) as ServiceNameEnum] -
          SERVICE_NAME_ORDER_MAP[SERVICE_NAME_MAP.get(s2) as ServiceNameEnum]
        );
      });
    }
    return services.map((service) =>
      dashboardServiceLineSeries({
        data,
        service,
      })
    );
  }, [data]);

  return (
    <ECharts
      series={series}
      xAxis={{
        data: dashboardTimerangeXData(
          data[Object.keys(data)[0]]?.timerange,
          timeModel.offset
        ).map((timestamp) =>
          format({
            timestamp,
            interval: interval as TimeRangeEnum,
          })
        ),
      }}
      yAxis={{
        name: t('dashboard.charts.axis.label.count'),
      }}
      grid={{ top: 20, right: 20, bottom: 165, left: 80 }}
      height="470px"
      {...echartsProps}
    />
  );
};
